/**
Project: Voice Panel (c)
Title: Numbers Import
Description: Component to display the Import the numbers.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/


import React, { Component } from 'react';
import { connect } from "react-redux";
import axios from "axios";
import {
    showPageWaitDialog,
    hidePageWaitDialog,
} from "../../common/actions/general-actions";
import {
    Dialog,
    Text,
    Divider,
    Button,
    Flex
} from "@fluentui/react-northstar";
import IntlUtil from "../../../../core/helpers/intl-util";
import PageUtil from "../../../../core/helpers/page-util";
import {
    getInventoryFileData,
    getDeviceFileData
} from "../actions/number-inventory-actions";

class NumberExport extends Component {
    _isMounted = false;
    _axiosSource = axios.CancelToken.source();
    _cancelToken = { cancelToken: this._axiosSource.token };
    _intl_ns_common = "common";
    _intl_ns_vpa_number_inventory = "vpa_number_inventory";
    constructor(props) {
        super(props);
        this.state = {
            showExportStatusDialog: false,
            exportInfoMessage: null
        }
    }


    setStateAsync = (state) => {
        if (this._isMounted) {
            return new Promise((resolve) => {
                this.setState(state, resolve);
            });
        }
    };

    async componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
        this._axiosSource.cancel(
            IntlUtil.getText(
                this._intl_ns_common,
                "notification.warning.requestCancelled"
            )
        );
    }


    renderExportStatus = () => {
        return (
            <Dialog
                backdrop={true}
                confirmButton={IntlUtil.getText(
                    this._intl_ns_vpa_number_inventory,
                    "content.ok"
                )}
                onConfirm={() => {
                    this.setState({ showExportStatusDialog: false });
                }}
                open={this.state.showExportStatusDialog}
                content={
                    <Text
                        className="vpa-page-dialog-info-text"
                        content={this.state.exportInfoMessage}
                    />
                }
                className="vpa-page-dialog"
            />
        )
    }


    exportInventory = async () => {
        await this.props.showPageWaitDialog(
            IntlUtil.getText(
                this._intl_ns_vpa_number_inventory,
                "notification.info.pleaseWaitExportingData"
            )
        );
        await this.setStateAsync({ showExportStatusDialog: false });
        await this.setStateAsync({ exportInfoMessage: null });
        await this.props.fetchNumbersData();
        const csvFileData = await getInventoryFileData(
            this._intl_ns_vpa_number_inventory,
            this.props.numberRecord
        );
        const csvFileName = "numbers.csv";
        await PageUtil.downloadCSVFile(csvFileName, csvFileData);
        await this.setStateAsync({
            exportInfoMessage: IntlUtil.getText(
                this._intl_ns_vpa_number_inventory,
                "notification.info.exportNumberInventory"
            )
        });
        await this.setStateAsync({ showExportStatusDialog: true });
        await this.props.hidePageWaitDialog();
    };

    exportdevice = async () => {
        await this.props.showPageWaitDialog(
            IntlUtil.getText(
                this._intl_ns_vpa_number_inventory,
                "notification.info.pleaseWaitExportingData"
            )
        );
        await this.setStateAsync({ showExportStatusDialog: false });
        await this.setStateAsync({ exportInfoMessage: null });
        await this.props.fetchDevicesData();
        const csvFileData = await getDeviceFileData(
            this.props.countryRecord,
            this._intl_ns_vpa_number_inventory,
            this.props.deviceRecord
        );
        const csvFileName = "devices.csv";
        await PageUtil.downloadCSVFile(csvFileName, csvFileData);
        await this.setStateAsync({
            exportInfoMessage: IntlUtil.getText(
                this._intl_ns_vpa_number_inventory,
                "notification.info.exportDeviceInventory"
            )
        });
        await this.setStateAsync({ showExportStatusDialog: true });
        await this.props.hidePageWaitDialog();
    }

    render() {
        return (
            <>
                {this.renderExportStatus()}
                < Dialog open={this.props.showDialogBox}
                    className="vpa-dialog-Panel"
                    header={
                        <>
                            <Text>
                                {IntlUtil.getText(
                                    this._intl_ns_vpa_number_inventory,
                                    "content.export"
                                )}
                            </Text>
                            <Divider size={1} />
                        </>
                    }
                    content={
                        <>
                            <Button onClick={() => this.exportInventory()}
                                className="vpa-usn-button m-t-10"
                                primary
                                content={IntlUtil.getText(
                                    this._intl_ns_vpa_number_inventory,
                                    "content.exportNumber"
                                )}></Button>

                            <Button onClick={() => this.exportdevice()}
                                className="vpa-usn-button  m-t-10"
                                primary
                                content={IntlUtil.getText(
                                    this._intl_ns_vpa_number_inventory,
                                    "content.exportDevice"
                                )}></Button>
                        </>
                    }
                    footer={{
                        children: () => {
                            return (
                                <Flex gap="gap.small">
                                    <Button onClick={() => {
                                        this.props.hideDialogBox();
                                    }} content={
                                        IntlUtil.getText(
                                            this._intl_ns_vpa_number_inventory,
                                            "content.close"
                                        )
                                    } />
                                </Flex>
                            )
                        },
                    }}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => ({});

const mapActionToProps = {
    showPageWaitDialog,
    hidePageWaitDialog,
};


export default connect(mapStateToProps, mapActionToProps)(NumberExport);